<template>
  <header class="main-header" :class="{ 'is-sticky': isSticky }">
    <div class="container container-wide">
      <h1>
        <router-link to="/" title="The App Capital">
          <img class="logo" src="@/assets/img/logo.svg" title="The App Capital">
        </router-link>
      </h1>
      <nav>
        <ul class="main-menu">
          <li>
            <a class="button is-size-6 has-text-black" href="https://github.com/theappcapital">
              <img width="20px" height="20px" src="@/assets/img/github_logo.svg"/>
            </a>
          </li>
          <li>
            <a target="_top" class="button is-size-6 has-text-black" href="mailto:thomasneuteboom@theappcapital.com">Contact</a>
          </li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
import ScrollReveal from 'scrollreveal'

export default {
  name: 'MainHeader',
  data() {
    return {
      isSticky: false,
      lastScrollY: 0,
      isTransitioning: false
    }
  },
  mounted () {
    ScrollReveal().reveal('.main-header', {
      distance: '5%',
      origin: 'bottom',
      duration: 1000,
    });

    this.lastScrollY = window.scrollY;
    window.addEventListener('scroll', this.handleScroll, { passive: true });
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (this.isTransitioning) return;

      const scrollPosition = window.scrollY;
      const scrollingDown = scrollPosition > this.lastScrollY;

      // Only become sticky when scrolling DOWN past 50px.
      if (scrollingDown && scrollPosition > 50 && !this.isSticky) {
        this.isSticky = true;
        this.isTransitioning = true;
        setTimeout(() => { this.isTransitioning = false; }, 300);
      }
      // Only become non-sticky when scrolling UP past 20px.
      else if (!scrollingDown && scrollPosition < 20 && this.isSticky) {
        this.isSticky = false;
        this.isTransitioning = true;
        setTimeout(() => { this.isTransitioning = false; }, 300);
      }

      this.lastScrollY = scrollPosition;
    }
  }
}
</script>